export default "__VITE_ASSET__B_gLzooI__"